import { Component } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { CaseListComponent } from "../../shared/components/case/case-list/case-list.component";
import { MatDialog } from "@angular/material/dialog";
import { getDictionaryItem } from "../../shared/utils/dictionary.domain";
import { RouterLink } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { MatIconModule } from "@angular/material/icon";

import { Tile } from "../../shared/interfaces/tiles.interfaces";

@Component({
    selector: "app-front-page",
    standalone: true,
    imports: [MatCardModule, CaseListComponent, MatIconModule, RouterLink],
    templateUrl: "./front-page.component.html",
    styleUrl: "./front-page.component.scss"
})
export class FrontPageComponent {
    pageId: string = "front-page";

    constructor(
        public dialog: MatDialog,
        private authService: MsalService
    ) {}

    public getDictionaryItem = getDictionaryItem;

    public tiles: Tile[] = [
        {
            header: getDictionaryItem("frontpageArticlesHeader"),
            subheader: getDictionaryItem("frontpageArticlesSubheader"),
            icon: "dictionary",
            title: "Vidensartikler",
            link: "/videns-artikler",
            id: "videns-artikler-link"
        },
        {
            header: getDictionaryItem("frontpageCoursesHeader"),
            subheader: getDictionaryItem("frontpageCoursesSubheader"),
            icon: "school",
            title: "Kurser",
            link: "/kurser",
            id: "courses-link"
        },
        {
            header: getDictionaryItem("frontpageTeamviewerHeader"),
            subheader: getDictionaryItem("frontpageTeamviewerSubheader"),
            icon: "support_agent",
            title: "Åben Teamviewer",
            link: "https://get.teamviewer.com/softvaerket",
            id: "teamviewer-link",
            target: "_blank"
        },
        {
            header: getDictionaryItem("frontpageMessagesHeader"),
            subheader: getDictionaryItem("frontpageMessagesSubheader"),
            icon: "mail",
            title: "Beskedcenter",
            link: "/beskedcenter",
            id: "beskedcenter-link"
        }
    ];

    get isLoggedIn(): boolean {
        return this.authService.instance.getAllAccounts().length > 0;
    }
}
